<template>
  <el-dialog
    title="驳回流程"
    :visible.sync="visible"
    width="30%"
    top="15%"
    @close="close"
  >
    <el-input
      type="textarea"
      :rows="5"
      placeholder="输入驳回理由（必填）"
      v-model="suggest"
      maxlength="100"
    >
    </el-input>
    <span slot="footer" class="dialog-footer">
      <el-button type="info" class="w100f" @click="handleSubmit"
        >驳回</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "RejectQuestionnaireReviewDialog",
  data() {
    return {
      suggest: "",
      visible: false,
    };
  },
  methods: {
    open() {
      this.visible = true;
      this.suggest = "";
    },
    close() {
      this.visible = false;
    },
    handleSubmit() {
      if (!this.suggest.trim()) {
        this.$message.error("请输入驳回理由");
        return;
      }
      this.$emit("submit", this.suggest);
    },
  },
};
</script>

<style scoped>
.w100f {
  width: 100%;
}
</style>
